/* eslint-disable react/jsx-no-bind */
import React from "react";
import Grid from "@material-ui/core/Grid";
import EstablishmentForm from "components/EstablishmentForm/EstablishmentForm";
import { Typography } from "@material-ui/core";
import { withTranslation } from "react-i18next";

class Establishment extends React.Component {
  render() {
    const { t } = this.props;
    return (
      <div>
        <Grid container spacing={40} direction="column" justify="center" alignItems="center">
          <Grid item>
            <Typography variant="h4">{t("titles.establishment")}</Typography>
          </Grid>
          <Grid item md={6} xs={10} style={{}}>
            <EstablishmentForm />
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withTranslation()(Establishment);
